<script lang="ts">
    import { onMount } from 'svelte'

    import UpdateCardForm from './update-card-form.svelte'

    let purchaseId: string = undefined

    let loaded = false

    async function detectParams() {
        purchaseId = new URLSearchParams(window.location.search)?.get('id') || undefined
        loaded = true
    }

    onMount(async () => {
        await detectParams()
    })

    let gateway = null
    function showIssuer(ev) {
        gateway = ev.detail
    }
</script>

{#if loaded}
    <div class="page-checkout">
        <div class="page-checkout-bar" />
        <div class="checkout-container">
            <div class="company-info">
                <div>
                    <div class="checkout-business">{gateway?.issuerBusinessName || ''}</div>
                    <div class="checkout-legal">{gateway?.issuerLegalName || ''}</div>
                    <div class="checkout-document">Documento: {gateway?.issuerDocument || ''}</div>
                </div>
                <div>
                    <div class="checkout-address">Endereço: {gateway?.issuerAddress || ''}</div>
                    <div class="checkout-phone">
                        Telefone: {window.api.utils.utils.phoneFriendly(gateway?.issuerPhone) || ''}
                    </div>
                    <div class="checkout-email">E-mail do financeiro: {gateway?.issuerEmail || ''}</div>
                </div>
            </div>
            <UpdateCardForm {purchaseId} on:load={showIssuer} />
            <div class="seals">
                <div class="seal">
                    <img src="/img/seal_aws.png" alt="" />
                </div>
                <div class="seal">
                    <img src="/img/seal_cloudflare.png" alt="" />
                </div>
                <div class="seal">
                    <img src="/img/seal_card_token.png" alt="" />
                </div>
                <div class="seal">
                    <img src="/img/seal_pci.png" alt="" />
                </div>
                <div class="seal">
                    <img src="/img/seal_https.png" alt="" />
                </div>
            </div>
            <div class="secure-footer">
                Você está em um ambiente extremamente seguro.
                <br />
                Nossos servidores estão protegidos na maior fornecedora de Cloud Computing do mundo - Amazon AWS
                <br />
                A rota até nossos servidores está protegida pela maior rede de CDN e proteção do mundo - Cloudflare
                <br />
                Os dados de cartão são tokenizados. Não armazenamos as informações do cartão diretamente - Card Tokenization
                <br />
                Todos os nossos processadores de pagamento estão em conformidade com o padrão de mercado - PCI DSS Compliant
                <br />
                Todos os dados são protegidos com criptografia de ponta a ponta - HTTPS over TLS
                <br />
            </div>
        </div>
    </div>
{/if}
